import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingCart, User } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo Pequeninos OFICIAL */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.png"  // ← Brasão [file:95] renomeado
                alt="Pequeninos do Jockey" 
                className="h-12 w-auto md:h-14 hover:scale-105 transition-transform duration-200"
                loading="lazy"
              />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1">
            <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Início
            </Link>
            <Link to="/athletes" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Ex-Atletas
            </Link>
            <Link to="/championships" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Campeonatos
            </Link>
            <Link to="/categories" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Categorias
            </Link>
            <Link to="/schedules" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Horários
            </Link>
            <Link to="/shop" className="text-gray-700 hover:text-red-600 px-3 py-2 font-medium rounded-md transition-all duration-200">
              Loja
            </Link>
            
            {/* User Area */}
            {user ? (
              <>
                <div className="flex items-center space-x-2">
                  <User className="text-gray-500" size={18} />
                  <span className="text-sm font-medium text-gray-700">{user.name}</span>
                </div>
                <Button onClick={handleLogout} variant="outline" size="sm">
                  Sair
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button className="bg-red-600 hover:bg-red-700 text-white font-semibold" size="sm">
                  Entrar
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile hamburger */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 hover:text-red-600 transition-all"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">
          <div className="px-4 py-4 space-y-2">
            <Link 
              to="/" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Início
            </Link>
            <Link 
              to="/athletes" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Ex-Atletas
            </Link>
            <Link 
              to="/championships" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Campeonatos
            </Link>
            <Link 
              to="/categories" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Categorias
            </Link>
            <Link 
              to="/schedules" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Horários
            </Link>
            <Link 
              to="/shop" 
              className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-lg font-medium transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Loja
            </Link>
            
            {user ? (
              <>
                <div className="px-4 py-3 border-t">
                  <Link 
                    to={user.role === 'admin' ? '/admin' : '/parent-portal'} 
                    className="flex items-center text-gray-700 hover:text-red-600 py-2 font-medium"
                    onClick={() => setIsOpen(false)}
                  >
                    <User className="mr-2" size={18} />
                    Minha Área
                  </Link>
                  <Button onClick={handleLogout} variant="outline" size="sm" className="w-full mt-2">
                    Sair
                  </Button>
                </div>
              </>
            ) : (
              <Link to="/login" onClick={() => setIsOpen(false)}>
                <Button className="bg-red-600 hover:bg-red-700 w-full text-white font-semibold">
                  Entrar
                </Button>
              </Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;